export const updateQueryStringOnFieldChange = (
  e,
  { clearFields, searchParams, setSearchParams }
) => {
  const localClearField = clearFields || [];
  const { name, value } = e.target;
  const updatedSearchParams = new URLSearchParams(searchParams.toString());
  updatedSearchParams.set(name, value);
  if (localClearField.length !== 0) {
    localClearField.forEach((field) => updatedSearchParams.delete(field));
  }
  setSearchParams(updatedSearchParams.toString());
};
export const updateMultipleQueryStringOnFieldChange = (
  values,
  { clearFields, searchParams, setSearchParams }
) => {
  const localClearField = clearFields || [];
  const updatedSearchParams = new URLSearchParams(searchParams.toString());
  values.forEach(({ name, value }) => {
    updatedSearchParams.set(name, value);
  });

  if (localClearField.length !== 0) {
    localClearField.forEach((field) => updatedSearchParams.delete(field));
  }
  setSearchParams(updatedSearchParams.toString());
};

export const updateQueryStringWithParams = (
  name,
  value,
  { clearFields, searchParams, setSearchParams }
) => {
  const localClearField = clearFields || [];
  const updatedSearchParams = new URLSearchParams(searchParams.toString());
  if (updatedSearchParams.getAll(name).includes(value)) {
    updatedSearchParams.delete(name, value);
  } else {
    updatedSearchParams.append(name, value);
  }
  if (localClearField.length !== 0) {
    localClearField.forEach((field) => updatedSearchParams.set(field, ''));
  }
  setSearchParams(updatedSearchParams.toString());
};
